__webpack_require__.p = "/ClientApp/dist/react/";